import classnames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Button from '../Button/Button'

import styles from './MessageBox.module.scss'

type MessageBoxProps = React.PropsWithChildren<{
  close: (result: boolean) => void
  buttonLabel?: string
  className?: string
}>

export default React.memo(function MessageBox({ close, buttonLabel, className, children }: MessageBoxProps) {
  const { t } = useTranslation()

  return (
    <div className={classnames(styles.MessageBox, className)}>
      {children}
      <div className={styles.buttons}>
        <Button onClick={() => close(true)}>{buttonLabel || t('generic cta.ok')}</Button>
      </div>
    </div>
  )
})
